<ng-container>
    <div class="indicator-nav" *ngIf="itemCount().length > 1">
        <span *ngFor="let i of itemCount()" class="indicator-dot" [ngStyle]="{'color': selectedIndex == i? activeColor : inactiveColor}">
            <i class="fas fa-circle" ></i>
        </span>
    </div>
</ng-container>